export default "__VITE_ASSET__DRU$YKha__"